// extracted by mini-css-extract-plugin
export default {"accountNumber":"accountNumber--_9jppezX"};